import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "treasury_lang",
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Apply RTL/LTR direction and Arabic font on language change
const applyDirection = (lang) => {
  const isAr = lang === "ar";
  document.documentElement.dir = isAr ? "rtl" : "ltr";
  document.documentElement.lang = lang;
  // Add/remove RTL body class for CSS targeting
  if (isAr) {
    document.body.classList.add("rtl");
    document.body.classList.remove("ltr");
  } else {
    document.body.classList.add("ltr");
    document.body.classList.remove("rtl");
  }
};

// Apply on init
applyDirection(i18n.language);

// Apply on every language change
i18n.on("languageChanged", applyDirection);

export default i18n;
